<template>
  <div>
    <div id="printBox">
      <div class="logo">
        <img
          src="@/assets/images/logo.svg"
          width="100px"
        />
      </div>
      <div class="p-content">
        <div class="eig-table">
          <div class="table-header tr">
            <div class="td">出库单物品明细清单</div>
          </div>
          <div class="tr">
            <div
              class="td center"
              style="width:4%"
            >序号 </div>
            <div
              class="td center"
              style="width:8.5%"
            >单据日期 </div>
            <div
              class="td center"
              style="width:8.5%"
            >出库单号 </div>
            <div
              class="td center"
              style="width:8.5%"
            >仓库 </div>
            <div
              class="td center"
              style="width:8.5%"
            >存货名称 </div>
            <div
              class="td center"
              style="width:8.5%"
            >规格型号</div>
            <div
              class="td center"
              style="width:6%"
            >单位</div>
            <div
              class="td center"
              style="width:6%"
            >数量</div>
            <div
              class="td center"
              style="width:6%"
            >单价</div>
            <div
              class="td center"
              style="width:8%"
            >金额</div>
            <div
              class="td center"
              style="width:8%"
            >使用人</div>
            <div
              class="td center"
              style="width:8.5%"
            >使用属性</div>
            <div
              class="td center"
              style="width:11%"
            >使用人签名</div>
          </div>
          <div
            v-for="(item, index) in deatailList"
            class="tr"
            :key="index"
          >
            <div
              class="td center"
              style="width:4%"
            >
              <div class="tdContent">{{index + 1}}</div>
            </div>
            <div
              class="td center"
              style="width:8.5%"
            >
              <div class="tdContent">{{item.DetailNo}}</div>
            </div>
            <div
              class="td center"
              style="width:8.5%"
            >
              <div class="tdContent">{{item.InventNo}}</div>
            </div>
            <div
              class="td center"
              style="width:8.5%"
            >
              <div class="tdContent">{{item.WarehouseName}}</div>
            </div>
            <div
              class="td center"
              style="width:8.5%"
            >
              <div class="tdContent">{{item.MaterialName}}</div>
            </div>
            <div
              class="td center"
              style="width:8.5%"
            >
              <div class="tdContent">{{item.Specifications}}</div>
            </div>
            <div
              class="td center"
              style="width:6%"
            >
              <div class="tdContent">{{item.Unit}}</div>
            </div>
            <div
              class="td center"
              style="width:6%"
            >
              <div class="tdContent">{{item.Numbers}}</div>
            </div>
            <div
              class="td center"
              style="width:6%"
            >
              <div class="tdContent">{{item.UnitPrice}}</div>
            </div>
            <div
              class="td center"
              style="width:8%"
            >
              <div class="tdContent">{{item.AllPrice}}</div>
            </div>
            <div
              class="td center"
              style="width:8%"
            >
              <div class="tdContent">{{item.UserName}}</div>
            </div>
            <div
              class="td center"
              style="width:8.5%"
            >
              <div class="tdContent">{{item.UseAttributes}}</div>
            </div>
            <div
              class="td center"
              style="width:11%"
            >
              <div style="width:100%;height:50px;;display: block;">
                <img
                  v-if="item.userSignSrc"
                  :src="item.userSignSrc"
                  width="100%"
                  height="100%"
                />
              </div>
            </div>
          </div>
          <div class="tr">
            <div
              class="td center"
              style="width:4%"
            >合计</div>
            <div
              class="td"
              style="width:8.5%"
            ></div>
            <div
              class="td"
              style="width:8.5%"
            ></div>
            <div
              class="td"
              style="width:8.5%"
            ></div>
            <div
              class="td"
              style="width:8.5%"
            ></div>
            <div
              class="td"
              style="width:8.5%"
            ></div>
            <div
              class="td"
              style="width:6%"
            ></div>
            <div
              class="td center"
              style="width:6%"
            >{{totalNum}}</div>
            <div
              class="td"
              style="width:6%"
            ></div>
            <div
              class="td center"
              style="width:8%"
            >{{totalMoney}}</div>
            <div
              class="td"
              style="width:8%"
            ></div>
            <div
              class="td"
              style="width:8.5%"
            ></div>
            <div
              class="td"
              style="width:11%"
            ></div>
          </div>
          <div class="tr">
            <div
              class="td"
              style="width:33.3%"
            >操作人：{{operatorName}}</div>
            <div
              class="td"
              style="width:33.3%"
            >打印日期：{{operatorTime}}</div>
            <div
              class="td"
              style="width:33.3%"
            >项目名称：{{projectName}}</div>
          </div>
        </div>
        <div class="eig-table-bottom">
          <div
            class="td"
            style="width:33.3%;position:relative;padding: 1rem 0.3rem;"
          >领料人：<div style="width:180px;height:60px;position:absolute;display: inline;top:0"><img
                :src="imgOutStock01"
                style="width:100%;height:100%"
              /></div>
            <div style="width:180px;height:60px;position:absolute;display: inline;top:0">
            </div>
          </div>
          <div
            class="td"
            style="width:33.3%;position:relative;padding: 1rem 0.3rem;"
          >审核人：<div style="width:180px;height:60px;position:absolute;display: inline;top:0"><img
                :src="imgOutStock02"
                style="width:100%;height:100%"
              /></div>
            <div style="width:180px;height:60px;position:absolute;display: inline;top:0">
            </div>
          </div>
        </div>
      </div>
      <div class="p-root"></div>
    </div>
    <!-- <button v-print="printboj">打印</button> -->
  </div>
</template>

<script>
import { GetOutStockedInfoByDetailId } from "@/modules/material/api/inventory.js";
export default {
  name: "OutStockDetailPrintPage",
  components: {},
  props: {
    data: {
      type: String,
      default: null,
    },
  },
  data () {
    return {
      deatailList: [],
      baseinfo: null,
      printboj: {
        id: "printBox",
        popTitle: "&nbsp;", // 打印配置页上方的标题
      },
      totalNum: 0,
      totalMoney: 0,
      materialCollectorSign: '',
      checkerSign: '',
      operatorName: '',
      projectName: '',
      operatorTime: '',
      imgOutStock01: '',
      imgOutStock02: '',
    };
  },
  computed: {

  },
  created () {
  },
  mounted () {
    this.initPageData()
  },
  activated () { },
  methods: {
    initPageData () {
      GetOutStockedInfoByDetailId(this.data).then((rep) => {
        if (rep.data.Code == 0) {
          let basedata = rep.data.Data
          this.deatailList = basedata.List;
          this.deatailList.forEach(e => {
            if (e && e.Numbers) {
              this.totalNum += e.Numbers * 1
              this.totalMoney += e.AllPrice * 1
            }
            if (e.Sign) {
              e.userSignSrc = "/common/CommonTemplateDown/PreView?id=" + (JSON.parse(e.Sign)).FileId
            }
          })
          if (basedata.SiginOut) {
            if (basedata.SiginOut.Sigin010) {
              this.imgOutStock01 = "/common/CommonTemplateDown/PreView?id=" + (JSON.parse(basedata.SiginOut.Sigin010)).FileId
            }
            if (basedata.SiginOut.Sigin020) {
              this.imgOutStock02 = "/common/CommonTemplateDown/PreView?id=" + (JSON.parse(basedata.SiginOut.Sigin020)).FileId
            }
          }
          this.operatorName = basedata.OperatorName
          this.projectName = this.deatailList[0].ProjectName
          this.operatorTime = basedata.PrintDate
        }
      });
    },
    print () {
      return this.printboj;
    },
  },
  beforeRouteLeave (to, from, next) {
    next();
  },
};
</script>
<style>
.main-table {
  border-collapse: collapse;
  margin: 0 auto;
  border: 1 !important;
}
.main-table td,
.main-table th {
  border: 1px solid #000;
}

.main-table td {
  padding: 0.5rem 0.3rem;
  min-height: 0.3rem;
}

.tdContent {
  white-space: pre-wrap;
  word-wrap: break-word;
}
</style>